/*
 *   File : summaryDual.js
 *   Author : https://evoqueinnovativelab.com
 *   Description : Dashboard summary card that shows a title, an icon and two
 *                 labelled metrics (used to group related stats into one card).
 *   Integrations : null
 *   Version : 1.0.0
 */

/*import packages*/
import React from 'react';

/*Style Import*/
import styles from '../../styles/components/summary.module.scss';

const SummaryDual = (props) => {
	const { title, icon, metrics = [] } = props.data || {};

	return (
		<div className={`${styles.e_dual_card} card`}>
			<div className={styles.e_dual_head}>
				<h5 className={styles.e_dual_title}>{title}</h5>
				{/* icons removed from summary cards - cluttered the section
				icon ?
					<div className={styles.e_dual_icon_bg}>
						<img src={icon} alt="" className={styles.e_dual_icon} />
					</div>
					:
					null
				*/}
			</div>
			<div className={styles.e_dual_metrics}>
				{
					metrics.map((item, index) => (
						<div className={styles.e_dual_metric} key={index}>
							<span className={styles.e_dual_label}>{item.label}</span>
							<span className={styles.e_dual_value}>{item.value}</span>
						</div>
					))
				}
			</div>
		</div>
	);
}

export default SummaryDual;
